'use strict';

require('es6-shim');

require('function.prototype.name/shim')();

require('./es2016');
